<!-- 实时动态 -->
<template>
    <div class="resource-dynamic">
        <div class="resource-dynamic-title">
            <div class="name">实时动态</div>
        </div>
        <div class="dynamic-wrap">
            <div class="left-container">
                <div class="top-container">
                    <div class="bubble-wrap">
                        <img src="../../../assets/images/qingxudataboard/bubble-bg.png" width="100%" height="100%">
                    </div>
                    <div class="bottom-circle">
                        <div class="circular1">
                            <img src="../../../assets/images/databoard/1.png" width="100%" height="100%">
                        </div>
                        <div class="circular2">
                            <img src="../../../assets/images/databoard/2.png" width="100%" height="100%">
                        </div>
                        <div class="circular1">
                            <img src="../../../assets/images/databoard/1.png" width="100%" height="100%">
                        </div>
                        <div class="circular3">
                            <img src="../../../assets/images/databoard/3.png" width="100%" height="100%">
                        </div>
                        <div class="circular4">
                            <img src="../../../assets/images/databoard/4.png" width="100%" height="100%">
                        </div>
                        <div class="circular5">
                            <img src="../../../assets/images/databoard/5.png" width="100%" height="100%">
                        </div>
                    </div>
                    <div class="item bubble1">
                        <span>教案</span>
                    </div>
                    <div class="item bubble2">
                        <span>导学课</span>
                    </div>
                    <div class="item bubble5">
                        <span>微课</span>
                    </div>
                    <div class="item bubble3">
                        <span>课件</span>
                    </div>
                </div>
            </div>
            <div class="right-container" style="height: 400px;">
                <ul id="dynamic-ul">
                    <template v-for="item in renderDynamicList">
                        <li :style="{ top: item.top + 'px', left: item.left + 'px', color: item.color }">{{ item.operation
                        }}
                        </li>
                    </template>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
import { getPlatformDynamicDataAPI } from "@/service/api.js";
export default {
    name: 'resource-dynamic',
    components: {
    },
    props: {
        //区域id
        regionId: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //学校id
        schoolId: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            dynamicData: [],
            dynamicList: [],
            top: [],
            left: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            color: ['#FFF', '#0EFCFF', '#4889FF', '#FAE17C'],
            scrollInterval: {},//动态滚动区间,
        }
    },
    computed: {
        intervalTime() {
            return [this.startTime, this.endTime];
        },
        renderDynamicList: {
            get: function () {
                if (this.dynamicData.length > 0) {
                    return this.initDynamicData(this.dynamicData);
                }
            }
        }
    },
    watch: {
        intervalTime() {
            this.getPlatformDynamicData();
        },
        schoolId() {
            this.getPlatformDynamicData();
        },
        address() {
            this.getPlatformDynamicData();
        }
    },
    methods: {
        /**
      * 初始化实时动态top,left,color
      */
        initDynamicData(list) {
            let _this = this;
            let minTop = 45;
            let newList = [];
            //判断动态是否小于9条 小于9条则复制3份 实现从底部滚动的效果
            if (list.length < 9) {
                for (let i = 0; i < 3 * list.length; i++) {
                    let dynamicObj = {};
                    dynamicObj.id = list[i % list.length].id;
                    dynamicObj.operation = list[i % list.length].operation;
                    dynamicObj.operation_time = list[i % list.length].operation_time;
                    dynamicObj.realname = list[i % list.length].realname;
                    dynamicObj.type = list[i % list.length].type;
                    dynamicObj.tempIndex = i;
                    newList.push(dynamicObj);
                }
            } else {
                newList = list;
            }

            for (let i = 1; i <= newList.length; i++) {
                let curTop = i * minTop;
                _this.top.push(curTop);

            }

            for (let j = 0; j < newList.length; j++) {
                var leftIndex = parseInt(_this.left.length * Math.random());
                newList[j]['left'] = _this.left[leftIndex];
                var colorIndex = parseInt(4 * Math.random());
                newList[j]['top'] = _this.top[j];
                newList[j]['color'] = _this.color[colorIndex];
            }

            _this.scrollInterval.minTop = minTop;
            _this.scrollInterval.maxTop = minTop * newList.length - 30;

            this.timer = setInterval(_this.dynamicScroll, 20);
            return newList;
        },
        /**
          * @name 获取平台资源统计
          */
        async getPlatformDynamicData() {
            try {
                this.dynamicData = [];
                let params = {
                    regionId: this.regionId,
                    provinceId: this.provinceId,
                    cityId: this.cityId,
                    districtId: this.districtId,
                    address: this.address,
                    startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                    endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                    schoolId: this.schoolId,
                }
                const res = await getPlatformDynamicDataAPI(params);
                this.dynamicData = res;
                // console.log(this.dynamicData);
            } catch (err) {
                console.error(err);
            }
        }
    },
    mounted() {
        //  获取平台资源统计
        this.getPlatformDynamicData();

    }
}


</script>
<style lang="scss" scoped>
@import "../../../style/databoard";

.resource-dynamic {
    width: 100%;
    height: 455px;
    margin-top: 15px;
    background: rgba(9, 19, 66, 0.6);
    border: 1px solid #427CC2;
    border-radius: 0px 0px 4px 4px;

    .resource-dynamic-title {
        background: url("~@/assets/images/qingxudataboard/center_center_bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

}

.left-container {
    height: 95% !important;
}

.right-container {
    #dynamic-ul {
        & li {
            cursor: pointer;
        }

        height: 100%;
        animation: infinitevertical 15s linear infinite;

        &:hover {
            animation-play-state: paused;
        }

    }
}

.bubble1 {
    background-image: url("../../../assets/images/qingxudataboard/bubble-one.png");
    background-size: 100% 100%;
}

.bubble2 {
    background-image: url("../../../assets/images/qingxudataboard/bubble-two.png");
    background-size: 100% 100%;
}

.bubble3 {
    background-image: url("../../../assets/images/qingxudataboard/bubble-three.png");
    background-size: 100% 100%;
}

.bubble5 {
    background-image: url("../../../assets/images/qingxudataboard/bubble-four.png");
    background-size: 100% 100%;
}

/* 无限滚动垂直 */
@keyframes infinitevertical {
    0% {
        transform: translateY(0%);
    }

    100% {
        transform: translateY(-75%);
    }
}
</style>